import { FormikHelpers } from "formik";
import { useCreatePhonecentersSysModel } from "./api/createPhonecentersSysModel";
import PhonecentersSysModelForm from "./PhonecentersSysModelForm";


const CreatePhonecentersSysModel = ({handleCloseModal}: CreateModelProps)  => {
  const createPhonecentersSysModelMutation = useCreatePhonecentersSysModel({data: {}});

  const initialValues: IPostNewPhonecentersSysModel = {
    description: "",
    deleted: false
  };

  const handleSubmit = async (values: IPostNewPhonecentersSysModel, { setSubmitting }: FormikHelpers<IPostNewPhonecentersSysModel>): Promise<void> => {
    try {
      await createPhonecentersSysModelMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <PhonecentersSysModelForm initialValues={initialValues} type="create" onSubmit={handleSubmit} />
  )
}

interface CreateModelProps {
  handleCloseModal: () => void;
}

export default CreatePhonecentersSysModel;